// @generated
import { PapiDeviation } from '@wix/da-papi-types';

export const flashDeviations: PapiDeviation[] = [
  {
    deviationId: 401165483,
    typeId: 1,
    url: 'https://www.deviantart.com/jcling/art/Pokemon-Trainer-Creator-401165483',
    title: 'Pokemon Trainer Creator',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2013-09-18T17:17:07-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 26676807,
      useridUuid: '3c1ccfde-6e5e-4fd4-b916-b742af539010',
      username: 'jcling',
      usericon: 'https://a.deviantart.net/avatars-big/j/c/jcling.png?10',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 5032,
      favourites: 15225,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/3c1ccfde-6e5e-4fd4-b916-b742af539010/d6mud9n-5d4b61b0-1a31-4cdb-bfa0-4b1c2b7f4289.jpg',
      prettyName: 'pokemon_trainer_creator_by_jcling_d6mud9n',
      types: [
        {
          t: '150',
          r: -1,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 100,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          c: 'v1/fill/w_300,h_200,q_75,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '300W',
          r: -1,
          c: 'v1/fill/w_300,h_200,q_75,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '250T',
          r: -1,
          c: 'v1/fill/w_300,h_200,q_75,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '350T',
          r: -1,
          c: 'v1/fill/w_300,h_200,q_75,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '400T',
          r: -1,
          c: 'v1/fill/w_300,h_200,q_75,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 300,
        },
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_300,h_200,q_75,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 300,
          f: 72584,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_300,h_200,q_75,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 300,
        },
        {
          t: 'fullview',
          r: -1,
          h: 200,
          w: 300,
          f: 72584,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=650&filewidth=765&filename=wixmp%3Af%2F3c1ccfde-6e5e-4fd4-b916-b742af539010%2Fd6mud9n-46b1ce86-faa3-4ca2-b3f4-3828b73322e1.swf',
          h: 650,
          w: 765,
          f: 17001909,
        },
      ],
    },
  },
  {
    deviationId: 58128768,
    typeId: 1,
    url: 'https://www.deviantart.com/go-devil-dante/art/Avatar-Zuko-the-fire-lord-58128768',
    title: 'Avatar: Zuko the fire lord',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2007-06-21T18:52:40-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 945690,
      useridUuid: '0caf2159-8504-4cec-8626-576b913ea096',
      username: 'Go-Devil-Dante',
      usericon: 'https://a.deviantart.net/avatars-big/g/o/go-devil-dante.gif',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 16048,
      favourites: 55743,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/0caf2159-8504-4cec-8626-576b913ea096/dylwg0-62aece36-17ea-406d-a834-dcd99d2c781c.jpg',
      prettyName: 'avatar__zuko_the_fire_lord_by_go_devil_dante_dylwg0',
      types: [
        {
          t: '150',
          r: -1,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 109,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          c: 'v1/fill/w_275,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 275,
        },
        {
          t: '300W',
          r: -1,
          c: 'v1/fit/w_300,h_400,q_70,strp/<prettyName>-300w.jpg',
          h: 218,
          w: 300,
        },
        {
          t: '250T',
          r: -1,
          c: 'v1/fill/w_344,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 344,
        },
        {
          t: '350T',
          r: -1,
          c: 'v1/fill/w_481,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 481,
        },
        {
          t: '400T',
          r: -1,
          c: 'v1/fill/w_550,h_400,q_75,strp/<prettyName>-fullview.jpg',
          h: 400,
          w: 550,
        },
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_550,h_400,q_75,strp/<prettyName>-fullview.jpg',
          h: 400,
          w: 550,
          f: 23862,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_550,h_400,q_75,strp/<prettyName>-fullview.jpg',
          h: 400,
          w: 550,
        },
        {
          t: 'fullview',
          r: -1,
          h: 400,
          w: 550,
          f: 23862,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=400&filewidth=550&filename=wixmp%3Af%2F0caf2159-8504-4cec-8626-576b913ea096%2Fdylwg0-a8e32f9d-aca2-4b68-988a-4d234a550315.swf',
          h: 400,
          w: 550,
          f: 1294967,
        },
      ],
    },
  },
  {
    deviationId: 412271520,
    typeId: 1,
    url: 'https://www.deviantart.com/thatguy1945/art/Petting-Fluttershy-INTERACTIVE-412271520',
    title: 'Petting Fluttershy - INTERACTIVE!',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2013-11-08T04:59:22-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 24220717,
      useridUuid: '8ecea386-9b23-457d-9c77-b2e084c6aa96',
      username: 'thatguy1945',
      usericon: 'https://a.deviantart.net/avatars-big/t/h/thatguy1945.gif?3',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 1680,
      favourites: 5382,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/8ecea386-9b23-457d-9c77-b2e084c6aa96/d6tgeqo-95890e0a-e1c3-4b62-a3a9-01a079d7b5ca.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 150,
          w: 150,
          f: 891379,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 150,
          w: 150,
          f: 891379,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=480&filewidth=640&filename=wixmp%3Af%2F8ecea386-9b23-457d-9c77-b2e084c6aa96%2Fd6tgeqo-3c2e2782-ac40-4406-93a8-f75310636ea1.swf',
          h: 480,
          w: 640,
          f: 2024899,
        },
      ],
    },
  },
  {
    deviationId: 290247099,
    typeId: 1,
    url: 'https://www.deviantart.com/here5year/art/Clancy-Wiggum-Interactive-Flash-290247099',
    title: 'Clancy Wiggum Interactive Flash!',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2012-03-14T00:50:47-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 20293483,
      useridUuid: '1f676735-e6ce-4450-8bc7-8b8553c0ca25',
      username: 'here5year',
      usericon: 'https://a.deviantart.net/avatars-big/h/e/here5year.png?14',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 1109,
      favourites: 4069,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/1f676735-e6ce-4450-8bc7-8b8553c0ca25/d4st03f-2d0d0b10-ffd7-4ae1-b0f4-1664093b416d.jpg',
      prettyName: 'clancy_wiggum_interactive_flash__by_here5year_d4st03f',
      types: [
        {
          t: '150',
          r: -1,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 115,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          c: 'v1/fill/w_260,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 260,
        },
        {
          t: '300W',
          r: -1,
          c: 'v1/fit/w_300,h_374,q_70,strp/<prettyName>-300w.jpg',
          h: 231,
          w: 300,
        },
        {
          t: '250T',
          r: -1,
          c: 'v1/fill/w_325,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 325,
        },
        {
          t: '350T',
          r: -1,
          c: 'v1/fill/w_455,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 455,
        },
        {
          t: '400T',
          r: -1,
          c: 'v1/fill/w_486,h_374,q_75,strp/<prettyName>-fullview.jpg',
          h: 374,
          w: 486,
        },
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_486,h_374,q_75,strp/<prettyName>-fullview.jpg',
          h: 374,
          w: 486,
          f: 20253,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_486,h_374,q_75,strp/<prettyName>-fullview.jpg',
          h: 374,
          w: 486,
        },
        {
          t: 'fullview',
          r: -1,
          h: 374,
          w: 486,
          f: 20253,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=380&filewidth=490&filename=wixmp%3Af%2F1f676735-e6ce-4450-8bc7-8b8553c0ca25%2Fd4st03f-1112b3fa-c377-4399-adf4-9504b92294ad.swf',
          h: 380,
          w: 490,
          f: 463198,
        },
      ],
    },
  },
  {
    deviationId: 182063588,
    typeId: 1,
    url: 'https://www.deviantart.com/michelvictor/art/Gloom-Gumroad-Tutorial-182063588',
    title: 'Gloom |Gumroad Tutorial|',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2010-10-09T11:13:13-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 9778500,
      useridUuid: '648c114e-728a-4e4a-88de-990d91bea064',
      username: 'MichelVictor',
      usericon: 'https://a.deviantart.net/avatars-big/m/i/michelvictor.gif?3',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 3189,
      favourites: 11238,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/648c114e-728a-4e4a-88de-990d91bea064/d30e95w-6d4852c6-f879-4fec-9ae3-94206b05540c.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 150,
          w: 150,
          f: 448047,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 150,
          w: 150,
          f: 448047,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=1080&filewidth=1600&filename=wixmp%3Af%2F648c114e-728a-4e4a-88de-990d91bea064%2Fd30e95w-2d1d79a8-4e1d-404c-89f5-45c42881d9b6.swf',
          h: 1080,
          w: 1600,
          f: 4326271,
        },
      ],
    },
  },
  {
    deviationId: 257557272,
    typeId: 1,
    url: 'https://www.deviantart.com/kp-shadowsquirrel/art/Trixie-Pose-1-257557272',
    title: 'Trixie - Pose 1',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2011-09-09T12:17:57-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 8313659,
      useridUuid: '8de50d19-9150-4c66-a1ba-70dd0ec2e299',
      username: 'KP-ShadowSquirrel',
      usericon: 'https://a.deviantart.net/avatars-big/k/p/kp-shadowsquirrel.jpg?1',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 1360,
      favourites: 8027,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/8de50d19-9150-4c66-a1ba-70dd0ec2e299/d49ccgo-e3e31024-95b0-41bc-bd51-e5eb26750c21.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 133,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 133,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 133,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 133,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 133,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 133,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 133,
          w: 150,
          f: 526871,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 133,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 133,
          w: 150,
          f: 526871,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=800&filewidth=900&filename=wixmp%3Af%2F8de50d19-9150-4c66-a1ba-70dd0ec2e299%2Fd49ccgo-2b044799-b4b4-420a-9d83-d4dca751d855.swf',
          h: 800,
          w: 900,
          f: 12848681,
        },
      ],
    },
  },
  {
    deviationId: 108261694,
    typeId: 1,
    url: 'https://www.deviantart.com/joshpurple/art/Blue-Ring-Octopus-108261694',
    title: 'Blue Ring Octopus',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2009-01-02T23:55:00-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 2700009,
      useridUuid: '2fb76792-6a5e-4ddf-b7bf-6eec360f85c4',
      username: 'joshpurple',
      usericon: 'https://a.deviantart.net/avatars-big/j/o/joshpurple.png?5',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 1340,
      favourites: 5301,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/2fb76792-6a5e-4ddf-b7bf-6eec360f85c4/d1sgf9a-ad89bf42-0e50-470b-8d58-cbb9b9b14090.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 113,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 113,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 113,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 113,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 113,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 113,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 113,
          w: 150,
          f: 286169,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 113,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 113,
          w: 150,
          f: 286169,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=480&filewidth=640&filename=wixmp%3Af%2F2fb76792-6a5e-4ddf-b7bf-6eec360f85c4%2Fd1sgf9a-6207ba62-9667-42e6-a8e4-f0420905ca21.swf',
          h: 480,
          w: 640,
          f: 2511427,
        },
      ],
    },
  },
  {
    deviationId: 408492917,
    typeId: 1,
    url: 'https://www.deviantart.com/memedokis/art/pokemen-408492917',
    title: 'pokemen',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2013-10-20T13:29:58-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 18696459,
      useridUuid: '4b4927e9-f93d-4f39-b66b-9f0eb91a427a',
      username: 'memedokis',
      usericon: 'https://a.deviantart.net/avatars-big/m/e/memedokis.jpg?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 384,
      favourites: 5634,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/4b4927e9-f93d-4f39-b66b-9f0eb91a427a/d6r7f5h-2a9b32f5-5ef0-4e7a-b713-73379beeae1e.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 150,
          w: 150,
          f: 78122,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 150,
          w: 150,
          f: 78122,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=1150&filewidth=1275&filename=wixmp%3Af%2F4b4927e9-f93d-4f39-b66b-9f0eb91a427a%2Fd6r7f5h-124c2fd6-7de9-40e6-9f31-a7d3e63e4bec.swf',
          h: 1150,
          w: 1275,
          f: 354671,
        },
      ],
    },
  },
  {
    deviationId: 564687895,
    typeId: 1,
    url: 'https://www.deviantart.com/tsaoshin/art/The-Struggle-is-Real-564687895',
    title: 'The Struggle is Real',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2015-10-06T17:21:09-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 713265,
      useridUuid: 'd125df43-37f9-4450-a601-50d3aa7fa501',
      username: 'TsaoShin',
      usericon: 'https://a.deviantart.net/avatars-big/t/s/tsaoshin.gif?3',
      type: 'volunteer',
      isNewDeviant: false,
    },
    stats: {
      comments: 1558,
      favourites: 5304,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/d125df43-37f9-4450-a601-50d3aa7fa501/d9c77yv-c70b9a3a-d41e-464f-a301-5903dca8d08f.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 150,
          w: 150,
          f: 11524,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 150,
          w: 150,
          f: 11524,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=1000&filewidth=1000&filename=wixmp%3Af%2Fd125df43-37f9-4450-a601-50d3aa7fa501%2Fd9c77yv-294855c1-c48b-4555-a560-f8c3dc43f476.swf',
          h: 1000,
          w: 1000,
          f: 491319,
        },
      ],
    },
  },
  {
    deviationId: 64252110,
    typeId: 1,
    url: 'https://www.deviantart.com/shidabeeda/art/Everygirls-dress-up-64252110',
    title: 'Everygirls dress up',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2007-09-06T12:15:35-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: false,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 2591739,
      useridUuid: '99af2072-753e-4bff-ac8a-443314969ba9',
      username: 'shidabeeda',
      usericon: 'https://a.deviantart.net/avatars-big/s/h/shidabeeda.png?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 850,
      favourites: 10473,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/99af2072-753e-4bff-ac8a-443314969ba9/d12958u-cd5dbffe-b8a7-405e-819a-bf8fd03b0c41.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 150,
          w: 150,
          f: 22432,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 150,
          w: 150,
          f: 22432,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=700&filewidth=900&filename=wixmp%3Af%2F99af2072-753e-4bff-ac8a-443314969ba9%2Fd12958u-efa91014-44ba-4fa0-963c-e99114fc9d2a.swf',
          h: 700,
          w: 900,
          f: 599676,
        },
      ],
    },
  },
  {
    deviationId: 11117398,
    typeId: 1,
    url: 'https://www.deviantart.com/shock-value/art/Interactive-Buddy-v-1-02-11117398',
    title: 'Interactive Buddy v.1.02',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2004-10-03T13:32:50-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 427938,
      useridUuid: 'a4ef3e2a-5b92-48c0-a9bb-85d89a40f93c',
      username: 'shock-value',
      usericon: 'https://a.deviantart.net/avatars-big/s/h/shock-value.gif',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 12572,
      favourites: 36428,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/a4ef3e2a-5b92-48c0-a9bb-85d89a40f93c/d6ma8m-ede38b81-4bcf-4c04-8f33-b3f36aa323fb.jpg',
      prettyName: 'interactive_buddy_v_1_02_by_shock_value_d6ma8m',
      types: [
        {
          t: '150',
          r: -1,
          c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
          h: 100,
          w: 100,
        },
        {
          t: '200H',
          r: -1,
          c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
          h: 100,
          w: 100,
        },
        {
          t: '300W',
          r: -1,
          c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
          h: 100,
          w: 100,
        },
        {
          t: '250T',
          r: -1,
          c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
          h: 100,
          w: 100,
        },
        {
          t: '350T',
          r: -1,
          c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
          h: 100,
          w: 100,
        },
        {
          t: '400T',
          r: -1,
          c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
          h: 100,
          w: 100,
        },
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
          h: 100,
          w: 100,
          f: 21885,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_100,h_100,q_75,strp/<prettyName>-fullview.jpg',
          h: 100,
          w: 100,
        },
        {
          t: 'fullview',
          r: -1,
          h: 100,
          w: 100,
          f: 21885,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=400&filewidth=550&filename=wixmp%3Af%2Fa4ef3e2a-5b92-48c0-a9bb-85d89a40f93c%2Fd6ma8m-7c867fff-a7d2-4e2a-9b1b-1703b1a4bfda.swf',
          h: 400,
          w: 550,
          f: 1553105,
        },
      ],
    },
  },
  {
    deviationId: 40263387,
    typeId: 1,
    url: 'https://www.deviantart.com/dark-reign/art/AKAMARU-hampster-DANCER-CV-40263387',
    title: 'AKAMARU hampster DANCER CV',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2006-09-23T09:38:45-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: false,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1571489,
      useridUuid: '829b2b31-8411-4d08-a4fa-be54454c85ef',
      username: 'dark-reign',
      usericon: 'https://a.deviantart.net/avatars-big/d/a/dark-reign.jpg?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 457,
      favourites: 4188,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/829b2b31-8411-4d08-a4fa-be54454c85ef/dnyzff-54b7f7c8-5a83-448b-8120-d8cd422f4f04.jpg',
      prettyName: 'akamaru_hampster_dancer_cv_by_dark_reign_dnyzff',
      types: [
        {
          t: '150',
          r: -1,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 104,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          c: 'v1/fill/w_288,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 288,
        },
        {
          t: '300W',
          r: -1,
          c: 'v1/fit/w_300,h_272,q_70,strp/<prettyName>-300w.jpg',
          h: 209,
          w: 300,
        },
        {
          t: '250T',
          r: -1,
          c: 'v1/fill/w_359,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 359,
        },
        {
          t: '350T',
          r: -1,
          c: 'v1/fill/w_391,h_272,q_75,strp/<prettyName>-fullview.jpg',
          h: 272,
          w: 391,
        },
        {
          t: '400T',
          r: -1,
          c: 'v1/fill/w_391,h_272,q_75,strp/<prettyName>-fullview.jpg',
          h: 272,
          w: 391,
        },
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_391,h_272,q_75,strp/<prettyName>-fullview.jpg',
          h: 272,
          w: 391,
          f: 47738,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_391,h_272,q_75,strp/<prettyName>-fullview.jpg',
          h: 272,
          w: 391,
        },
        {
          t: 'fullview',
          r: -1,
          h: 272,
          w: 391,
          f: 47738,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=300&filewidth=600&filename=wixmp%3Af%2F829b2b31-8411-4d08-a4fa-be54454c85ef%2Fdnyzff-e1fb4ade-32e5-47a8-9b46-3d8e231e7250.swf',
          h: 300,
          w: 600,
          f: 4003854,
        },
      ],
    },
  },
  {
    deviationId: 452907890,
    typeId: 1,
    url: 'https://www.deviantart.com/whitemantisart/art/I-won-t-die-here-452907890',
    title: "I won't die here",
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2014-05-08T17:22:17-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: false,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 2904404,
      useridUuid: 'dba6aa2a-782d-4f06-a288-391ca5558794',
      username: 'WhiteMantisArt',
      usericon: 'https://a.deviantart.net/avatars-big/w/h/whitemantisart.gif?9',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 609,
      favourites: 7736,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/dba6aa2a-782d-4f06-a288-391ca5558794/d7hndyq-a073b95e-7385-44ac-a970-6d761aeb0142.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 150,
          w: 150,
          f: 631377,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 150,
          w: 150,
          f: 631377,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=868&filewidth=1280&filename=wixmp%3Af%2Fdba6aa2a-782d-4f06-a288-391ca5558794%2Fd7hndyq-2ca891f8-cb72-478b-ae75-c2cee73a5e0e.swf',
          h: 868,
          w: 1280,
          f: 7985763,
        },
      ],
    },
  },
  {
    deviationId: 414169728,
    typeId: 1,
    url: 'https://www.deviantart.com/4as/art/No-Touching-Flash-414169728',
    title: 'No Touching! [Flash]',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2013-11-17T08:17:31-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 9195442,
      useridUuid: 'b1e294a5-3091-45bb-bcbc-ea4e75780f32',
      username: '4as',
      usericon: 'https://a.deviantart.net/avatars-big/4/a/4as.jpg?6',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 4660,
      favourites: 18143,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/b1e294a5-3091-45bb-bcbc-ea4e75780f32/d6ul3eo-aae16b25-e46d-4ad6-8dab-22392f4885cc.png',
      prettyName: 'no_touching___flash__by_4as_d6ul3eo',
      types: [
        {
          t: '150',
          r: -1,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 109,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          c: 'v1/fill/w_276,h_200,q_80,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 276,
        },
        {
          t: '300W',
          r: -1,
          c: 'v1/fill/w_276,h_200,q_80,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 276,
        },
        {
          t: '250T',
          r: -1,
          c: 'v1/fill/w_276,h_200,q_80,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 276,
        },
        {
          t: '350T',
          r: -1,
          c: 'v1/fill/w_276,h_200,q_80,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 276,
        },
        {
          t: '400T',
          r: -1,
          c: 'v1/fill/w_276,h_200,q_80,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 276,
        },
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_276,h_200,q_80,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 276,
          f: 35123,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_276,h_200,q_80,strp/<prettyName>-fullview.jpg',
          h: 200,
          w: 276,
        },
        {
          t: 'fullview',
          r: -1,
          h: 200,
          w: 276,
          f: 35123,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=650&filewidth=900&filename=wixmp%3Af%2Fb1e294a5-3091-45bb-bcbc-ea4e75780f32%2Fd6ul3eo-d5c95f0a-0231-4233-8bd4-2a558b8fd828.swf',
          h: 650,
          w: 900,
          f: 440082,
        },
      ],
    },
  },
  {
    deviationId: 252802121,
    typeId: 1,
    url: 'https://www.deviantart.com/charfade/art/DeviantArt-Point-Calculator-252802121',
    title: 'DeviantArt Point Calculator',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2011-08-14T10:14:19-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: false,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 273519,
      useridUuid: 'b1e20040-c325-4e53-bae1-e34856b56cbe',
      username: 'charfade',
      usericon: 'https://a.deviantart.net/avatars-big/c/h/charfade.png?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 2032,
      favourites: 19912,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/b1e20040-c325-4e53-bae1-e34856b56cbe/d46ifd5-9a923b1e-cc69-451b-93a0-761460f7aaaa.png',
      prettyName: 'deviantart_point_calculator_by_charfade_d46ifd5',
      types: [
        {
          t: '150',
          r: -1,
          c: 'v1/fill/w_143,h_143,q_80,strp/<prettyName>-fullview.jpg',
          h: 143,
          w: 143,
        },
        {
          t: '200H',
          r: -1,
          c: 'v1/fill/w_143,h_143,q_80,strp/<prettyName>-fullview.jpg',
          h: 143,
          w: 143,
        },
        {
          t: '300W',
          r: -1,
          c: 'v1/fill/w_143,h_143,q_80,strp/<prettyName>-fullview.jpg',
          h: 143,
          w: 143,
        },
        {
          t: '250T',
          r: -1,
          c: 'v1/fill/w_143,h_143,q_80,strp/<prettyName>-fullview.jpg',
          h: 143,
          w: 143,
        },
        {
          t: '350T',
          r: -1,
          c: 'v1/fill/w_143,h_143,q_80,strp/<prettyName>-fullview.jpg',
          h: 143,
          w: 143,
        },
        {
          t: '400T',
          r: -1,
          c: 'v1/fill/w_143,h_143,q_80,strp/<prettyName>-fullview.jpg',
          h: 143,
          w: 143,
        },
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_143,h_143,q_80,strp/<prettyName>-fullview.jpg',
          h: 143,
          w: 143,
          f: 20394,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_143,h_143,q_80,strp/<prettyName>-fullview.jpg',
          h: 143,
          w: 143,
        },
        {
          t: 'fullview',
          r: -1,
          h: 143,
          w: 143,
          f: 20394,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=300&filewidth=300&filename=wixmp%3Af%2Fb1e20040-c325-4e53-bae1-e34856b56cbe%2Fd46ifd5-32a46818-029a-4b85-83db-ae2856691682.swf',
          h: 300,
          w: 300,
          f: 44666,
        },
      ],
    },
  },
  {
    deviationId: 126831037,
    typeId: 1,
    url: 'https://www.deviantart.com/yuumei/art/1000-W0RDS-126831037',
    title: '1000 W0RDS',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2009-06-22T09:12:01-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 391409,
      useridUuid: '454c2ed9-5cc2-484f-8449-167203bd7623',
      username: 'yuumei',
      usericon: 'https://a.deviantart.net/avatars-big/y/u/yuumei.gif?4',
      type: 'senior',
      isNewDeviant: false,
    },
    stats: {
      comments: 27873,
      favourites: 116513,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/454c2ed9-5cc2-484f-8449-167203bd7623/d23ifgd-1f3a90f6-990a-46a3-b196-4ad613437284.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 150,
          w: 150,
          f: 231673,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 150,
          w: 150,
          f: 231673,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=600&filewidth=750&filename=wixmp%3Af%2F454c2ed9-5cc2-484f-8449-167203bd7623%2Fd23ifgd-0e5b827c-77da-4591-9588-d54c1aacf5c6.swf',
          h: 600,
          w: 750,
          f: 9699572,
        },
      ],
    },
  },
  {
    deviationId: 758189763,
    typeId: 1,
    url: 'https://www.deviantart.com/polarisastrum/art/Valuable-Allies-Aksiothos-Story-Part-4-758189763',
    title: 'Valuable Allies (Aksiothos Story Part 4)',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-06T16:03:01-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 4713906,
      useridUuid: '13428f83-a6ab-49cf-b6a3-9af5876e4786',
      username: 'PolarisAstrum',
      usericon: 'https://a.deviantart.net/avatars-big/p/o/polarisastrum.png',
      type: 'senior',
      isNewDeviant: false,
    },
    stats: {
      comments: 20,
      favourites: 264,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/13428f83-a6ab-49cf-b6a3-9af5876e4786/dcjemyr-d2e3368b-2f68-415c-aa0d-26c3b1e0d0a8.png',
      prettyName: 'valuable_allies__aksiothos_story_part_4__by_polarisastrum_dcjemyr',
      types: [
        {
          t: '150',
          r: -1,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: -1,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: -1,
          c: 'v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: -1,
          c: 'v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: -1,
          c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 3593916,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: -1,
          h: 1080,
          w: 1920,
          f: 3593916,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=1080&filewidth=1920&filename=wixmp%3Af%2F13428f83-a6ab-49cf-b6a3-9af5876e4786%2Fdcjemyr-f09089ee-ba89-45fb-af69-08247ef3803c.swf',
          h: 1080,
          w: 1920,
          f: 3493051,
        },
      ],
    },
  },
  {
    deviationId: 758128836,
    typeId: 1,
    url: 'https://www.deviantart.com/unreal-forever/art/Zero-01-Welcome-Home-Animated-758128836',
    title: 'Zero-01 _ Welcome Home! (Animated)',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-08-06T11:18:33-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 24215794,
      useridUuid: 'c46eebc6-775c-4072-bcf7-3785025439cd',
      username: 'Unreal-Forever',
      usericon: 'https://a.deviantart.net/avatars-big/u/n/unreal-forever.png?9',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 197,
      favourites: 1397,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/c46eebc6-775c-4072-bcf7-3785025439cd/dcjdbyc-755299d0-8f99-4885-874d-567025265474.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 150,
          w: 150,
          f: 1366709,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 150,
          w: 150,
          f: 1366709,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=564&filewidth=900&filename=wixmp%3Af%2Fc46eebc6-775c-4072-bcf7-3785025439cd%2Fdcjdbyc-28dab1ed-5ca9-40e8-bc2b-09d8ed1efe75.swf',
          h: 564,
          w: 900,
          f: 1270830,
        },
      ],
    },
  },
  {
    deviationId: 756235228,
    typeId: 1,
    url: 'https://www.deviantart.com/dansyron/art/Ekh-Statcard-756235228',
    title: 'Ekh Statcard',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-07-25T09:52:04-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 14582585,
      useridUuid: 'eaa7d645-1fd8-455c-ae9d-9c51b9b9b1d1',
      username: 'DanSyron',
      usericon: 'https://a.deviantart.net/avatars-big/d/a/dansyron.gif?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 23,
      favourites: 440,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/eaa7d645-1fd8-455c-ae9d-9c51b9b9b1d1/dci8qu4-f1d30360-ba15-471f-95bf-5df55bda8280.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '200H',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '300W',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '250T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '350T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: '400T',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'preview',
          r: -1,
          h: 150,
          w: 150,
          f: 1594667,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 150,
          w: 150,
        },
        {
          t: 'fullview',
          r: -1,
          h: 150,
          w: 150,
          f: 1594667,
        },
        {
          t: 'flash',
          r: -2,
          s: 'https://sandbox.deviantart.com?fileheight=830&filewidth=720&filename=wixmp%3Af%2Feaa7d645-1fd8-455c-ae9d-9c51b9b9b1d1%2Fdci8qu4-13d67d52-935f-4e6b-ba6e-9b5a3b484e02.swf',
          h: 830,
          w: 720,
          f: 21644712,
        },
      ],
    },
  },
];
